<kendo-dialog title="{{ 'WIZARD-PROGRAM-TITLE' | translate }}" *ngIf="wizardOpened" (close)="close()" [minWidth]="700"
    [width]="700" [minHeight]="425">
    <kendo-stepper [steps]="steps" [currentStep]="currentStep" [linear]="false" class="w-100 mt-2 mb-2"
        (currentStepChange)="currentStepChange($event)" (activate)="activateStep($event)">
    </kendo-stepper>
    <div class="text-center mt-4 mb-4">
        <form novalidate [formGroup]="wizardForm" class="k-form ml-3 mr-3" style="position:relative;top:20%;">
            <div [ngSwitch]="currentStep+1">
                <!--Step 1: Want to use template or create new program?-->
                <div *ngSwitchCase="1">
                    <div>
                        <input type="radio" value="new" name="creationType" formControlName="creationType"
                            id="radioCreationTypeNew" kendoRadioButton />
                        <label class="k-radio-label" for="radioCreationTypeNew">{{'WIZARD-PROGRAM-NEW' | translate}}
                        </label>
                        <input type="radio" value="template" name="creationType" formControlName="creationType"
                            class=" ml-0" checked id="radioCreationTypeTemplate" kendoRadioButton />
                        <label class="k-radio-label" for="radioCreationTypeTemplate">{{'TEMPLATE' | translate}}</label>
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="creationType.touched && creationType.errors?.required">
                        {{'WIZARD-SELECTION-REQUIRED' | translate}}
                    </div>
                </div>
                <!--Step 2: Program Name-->
                <div *ngSwitchCase="2">
                    <div *ngIf="creationType.value === 'new'">
                        <input #programNameControl type="text" kendoTextBox formControlName="programName"
                            maxlength="255">
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                            *ngIf="programName.touched && programName.errors?.required">
                            {{'REQUIRED-NAME' | translate}}
                        </div>
                    </div>
                    <div *ngIf="creationType.value === 'template'">
                        <div class="row">
                            <div class="col-3 pr-0">
                                <label class="k-form-field text-right">
                                    <span class="k-text-uppercase dark">
                                        {{'TEMPLATE' | translate}}
                                    </span>
                                </label>
                            </div>
                            <div class="col-9">
                                <kendo-combobox #programTemplateControl id="programTemplatesDropdown"
                                    [data]="programTemplatesFiltered" [valueField]="'id'"
                                    formControlName="programTemplate" [textField]="'name'" [filterable]="true"
                                    (valueChange)="programTemplateChange($event)" (close)="searchTerm=''"
                                    (filterChange)="filterProgramTemplates($event)" class="w-100">
                                    <ng-template kendoComboBoxItemTemplate let-dataItem>
                                        <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                                        </span>
                                    </ng-template>
                                </kendo-combobox>
                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                    *ngIf="programTemplate.touched && programTemplate.errors?.required">
                                    {{'WIZARD-PROGRAM-TEMPLATE-REQUIRED' | translate}}
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-3 pr-0">
                                <label class="k-form-field text-right">
                                    <span class="k-text-uppercase dark">
                                        {{'NAME' | translate}}
                                    </span>
                                </label>
                            </div>
                            <div class="col-9">
                                <input #programNameControl type="text" kendoTextBox formControlName="programName"
                                    maxlength="255">
                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                    *ngIf="programName.touched && programName.errors?.required">
                                    {{'REQUIRED-NAME' | translate}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--Step 3: Program Category-->
                <div *ngSwitchCase="3">
                    <kendo-combobox #programCategoryControl id="programCategoryDropdown"
                        [data]="programCategoriesFiltered" [valueField]="'id'" [textField]="'name'"
                        formControlName="programCategory" [filterable]="true" class="w-100"
                        [itemDisabled]="itemInactive" (filterChange)="filterProgramCategories($event)">
                        <ng-template kendoComboBoxItemTemplate let-dataItem>
                            <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                            </span>
                        </ng-template>
                    </kendo-combobox>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="programCategory.touched && programCategory.errors?.required">
                        {{'REQUIRED-PROGRAM-CATEGORY' | translate}}
                    </div>
                </div>
                <!--Step 4: Primary Lead-->
                <div *ngSwitchCase="4">
                    <kendo-combobox #programLeadControl id="programLeadDropdown" [data]="programLeadsFiltered"
                        [valueField]="'id'" [textField]="'name'" formControlName="leader" [filterable]="true"
                        (close)="searchTerm=''" (filterChange)="filterProgramLeads($event)"
                        [itemDisabled]="itemDisabled" class="w-100">
                        <ng-template kendoComboBoxItemTemplate let-dataItem>
                            <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                            </span>
                        </ng-template>
                    </kendo-combobox>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="leader.touched && leader.errors?.required">
                        {{'REQUIRED-PROGRAM-LEAD' | translate}}
                    </div>
                </div>
                <!--Step 5: Secondary Leads / Data Analysts-->
                <div *ngSwitchCase="5">
                    <kendo-multiselect #programGroupsControl [data]="groupsFiltered" formControlName="programGroups"
                        [textField]="'name'" [filterable]="true" [valueField]="'id'" [autoClose]="true"
                        [itemDisabled]="itemInactive" (filterChange)="filterGroups($event)" (close)="searchTerm=''">
                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                            <div class="m-1">
                                <input type="checkbox" [checked]="isGroupSelected('programGroups', dataItem.id)"
                                    kendoCheckBox />
                                <label class="k-checkbox-label"
                                    innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                                </label>
                            </div>
                        </ng-template>
                    </kendo-multiselect>
                </div>
                <!--Step 6: Program Description-->
                <div *ngSwitchCase="6">
                    <textarea #programDescriptionControl kendoTextArea rows="3" formControlName="description"
                        maxlength="1024" class="w-100"></textarea>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="description.touched && description.errors?.required">
                        {{'REQUIRED-DESCRIPTION' | translate}}
                    </div>
                </div>
                <!--Step 7: Add Channel-->
                <div *ngSwitchCase="7">
                    <div class="row">
                        <div class="col-3 pr-0">
                            <label class="k-form-field text-right">
                                <span class="k-text-uppercase dark">
                                    {{'TEMPLATE' | translate}}
                                </span>
                            </label>
                        </div>
                        <div class="col-9">
                            <kendo-combobox #channelTemplateControl class="w-100" formControlName="channelTemplate"
                                [valuePrimitive]="false" [data]="templateGroupedChannelsFiltered" [textField]="'name'"
                                [valueField]="'id'" [filterable]="true" (close)="searchTerm=''"
                                (filterChange)="filterChannelTemplates($event)"
                                (valueChange)="channelTemplateChange($event)">
                                <ng-template kendoComboBoxItemTemplate let-dataItem>
                                    <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                                    </span>
                                </ng-template>
                            </kendo-combobox>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-3 pr-0">
                            <label class="k-form-field text-right">
                                <span class="k-text-uppercase dark">
                                    {{'NAME' | translate}}
                                </span>
                            </label>
                        </div>
                        <div class="col-9">
                            <input kendoTextBox (keydown)="validateKey($event)" formControlName="channelName"
                                maxlength="255" class="w-100 k-textbox" />
                            <div class="k-tooltip k-tooltip-validation" role="alert"
                                *ngIf="channelName.touched && channelName.errors?.required">
                                {{'REQUIRED-NAME' | translate}}
                            </div>
                        </div>
                    </div>
                </div>
                <!--Step 8: Assigned Staff Groups-->
                <div *ngSwitchCase="8">
                    <kendo-multiselect #channelGroupsControl [data]="groupsFiltered" formControlName="channelGroups"
                        [textField]="'name'" [filterable]="true" [valueField]="'id'" [autoClose]="true"
                        [itemDisabled]="itemInactive" (clickOutside)="setStaffCandidates()"
                        (filterChange)="filterGroups($event)" (close)="searchTerm=''">
                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                            <div class="m-1">
                                <input type="checkbox" [checked]="isGroupSelected('channelGroups', dataItem.id)"
                                    kendoCheckBox />
                                <label class="k-checkbox-label"
                                    innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                                </label>
                            </div>
                        </ng-template>
                    </kendo-multiselect>
                </div>
                <!--Step 9: Assigned Staff-->
                <div *ngSwitchCase="9">
                    <kendo-multiselect #channelStaffsControl [data]="staffCandidatesFiltered"
                        formControlName="channelStaffs" [textField]="'name'" [filterable]="true" [valueField]="'id'"
                        [autoClose]="true" [itemDisabled]="staffItemDisabled" (clickOutside)="setStaffCandidates()"
                        (filterChange)="filterStaffCandidates($event)" (close)="searchTerm=''">
                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                            <div class="m-1">
                                <input type="checkbox" [checked]="isGroupSelected('channelStaffs', dataItem.id)"
                                    kendoCheckBox />
                                <label class="k-checkbox-label"
                                    innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                                </label>
                            </div>
                        </ng-template>
                    </kendo-multiselect>
                </div>
                <!--Step 10: Channel Category-->
                <div *ngSwitchCase="10">
                    <kendo-combobox #channelCategoryControl class="w-100" formControlName="channelCategory"
                        [valuePrimitive]="false" [data]="channelCategoriesFiltered" [textField]="'name'"
                        [valueField]="'id'" [filterable]="true" [itemDisabled]="itemInactive" (close)="searchTerm=''"
                        (filterChange)="filterChannelCategories($event)">
                        <ng-template kendoComboBoxItemTemplate let-dataItem>
                            <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                            </span>
                        </ng-template>
                    </kendo-combobox>
                </div>
                <!--Step 11: Case Manager Assignment-->
                <div *ngSwitchCase="11">
                    <kendo-combobox #caseManagerAssignmentControl id="caseManagerAssignmentModeDropdown"
                        [data]="caseManagerAssignmentModes" [valueField]="'value'" [textField]="'text'"
                        formControlName="caseManagerAssignmentMode" class="w-100" [valuePrimitive]="true">
                    </kendo-combobox>
                </div>
                <!--Step 12: Sensitivity Flag-->
                <div *ngSwitchCase="12">
                    <kendo-multiselect #caseSensitivitiesControl id="sensitivities" [data]="sensitivitiesFiltered"
                        formControlName="sensitivities" [textField]="'displayName'" [filterable]="true"
                        [valueField]="'id'" (filterChange)="filterSensitivities($event)" (close)="searchTerm=''"
                        [autoClose]="true" [virtual]="virtualSensitivity" style="max-height: 137px; overflow: auto;">
                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text">
                            </span>
                        </ng-template>
                    </kendo-multiselect>
                </div>
                <!--Step 13: Limited Enrollment-->
                <div *ngSwitchCase="13">
                    <input #limitedEnrollmentControl type="checkbox" id="limitedEnrollment"
                        formControlName="limitedEnrollment" kendoCheckBox
                        [indeterminate]="limitedEnrollment.value === null">
                    <label class="k-checkbox-label k-text-uppercase dark" for="limitedEnrollment">
                        {{ 'LIMITED-ENROLLMENT' | translate }}
                    </label>
                </div>
                <!--Step 14: Limited View-->
                <div *ngSwitchCase="14">
                    <input #limitedViewControl type="checkbox" id="limitedView" formControlName="limitedView"
                        kendoCheckBox [indeterminate]="limitedView.value === null">
                    <label class="k-checkbox-label k-text-uppercase dark" for="limitedView">
                        {{ 'LIMITED-VIEW' | translate }}
                    </label>
                </div>
                <!--Step 15: Referral-->
                <div *ngSwitchCase="15">
                    <input #referralControl type="checkbox" id="referral" formControlName="referral" kendoCheckBox
                        [indeterminate]="referral.value === null">
                    <label class="k-checkbox-label k-text-uppercase dark" for="referral">
                        {{ 'REFERRAL' | translate }}
                    </label>
                </div>
                <!--Step 16: Private-->
                <div *ngSwitchCase="16">
                    <input #privateControl type="checkbox" id="private" formControlName="private" kendoCheckBox
                        [indeterminate]="private.value === null">
                    <label class="k-checkbox-label k-text-uppercase dark" for="private">
                        {{ 'PRIVATE' | translate }}
                    </label>
                </div>
                <!--Step 17: Dashboard Enrollment-->
                <div *ngSwitchCase="17">
                    <input #dashboardEnrollmentControl type="checkbox" id="dashboardEnrollment"
                        formControlName="dashboardEnrollment" kendoCheckBox
                        [indeterminate]="dashboardEnrollment.value === null">
                    <label class="k-checkbox-label k-text-uppercase dark" for="dashboardEnrollment">
                        {{ 'DASHBOARD-ENROLLMENT' | translate }}
                    </label>
                    <div class="text-center" *ngIf="!isStepValid(15)">
                        <div class="k-tooltip k-tooltip-validation" role="alert">
                            {{'WIZARD-DASHBOARD-ENROLLMENT-ERROR' | translate }}
                        </div>
                    </div>
                </div>
                <!--Step 18: Operational Targets-->
                <div *ngSwitchCase="18">
                    <div class="row">
                        <div class="col-5 pr-0">
                            <label class="k-form-field text-right">
                                <span class="k-text-uppercase dark">
                                    {{'PROGRAM-SUCCESS-TIME' | translate}}
                                </span>
                            </label>
                        </div>
                        <div class="col-7">
                            <div class="w-50">
                                <kendo-numerictextbox #channelGoalControl [format]="'n0'" formControlName="timeline"
                                    [min]="0" [max]="channelGoalMaxDays" (blur)="goalsBlur()">
                                </kendo-numerictextbox>
                            </div>
                            <div class="k-tooltip k-tooltip-validation" role="alert"
                                *ngIf="timeline.touched && timeline.errors?.required">
                                {{'SUCCESS-TIME-REQUIRED' | translate}}
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-5 pr-0">
                            <label class="k-form-field text-right">
                                <span class="k-text-uppercase dark">
                                    {{'PROGRAM-OVERALL-SUCCESS' | translate}}
                                </span>
                            </label>
                        </div>
                        <div class="col-7">
                            <div class="w-50">
                                <kendo-numerictextbox [format]="'n0'" formControlName="success" [min]="0" [max]="100"
                                    (blur)="goalsBlur()">
                                </kendo-numerictextbox>
                            </div>
                            <div class="k-tooltip k-tooltip-validation" role="alert"
                                *ngIf="success.touched && success.errors?.required">
                                {{'PROGRAM-OVERALL-SUCCESS-REQUIRED' | translate}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="text-center font-weight-bold montserrat mt-2">
        {{steps[currentStep].labelKey | translate}} <span *ngIf="isStepRequired(currentStep)">*</span>
    </div>
    <div [ngClass]="{'text-center': currentStep < steps.length-1}" class="step-hint w-75"
        [innerHTML]="getStepHintKey(currentStep) | translate | safe:'html'">
    </div>
    <kendo-dialog-actions>
        <button kendoButton *ngIf="currentStep > 0" (click)="previous()" style="position:absolute;left:15px"
            [disabled]="saving">
            {{ 'PREVIOUS' | translate }}
        </button>
        <button kendoButton *ngIf="currentStep < steps.length-1" (click)="next()" [disabled]="!isNextEnabled()">
            {{ 'NEXT' | translate}}
        </button>
        <button kendoButton *ngIf="currentStep === steps.length-1" (click)="save()" [disabled]="!formValid || saving">
            {{ 'SAVE' | translate}}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>